import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { withTheme } from '@pitchero/react-ui';
import HeaderContext from './context';

const HeaderProvider = ({ children, uiTheme }) => {
  const [values, setValues] = useState({
    backgroundImage: null,
    height: 0,
    backgroundColor: get(uiTheme, 'colors.headerBg'),
  });
  const { backgroundColor, backgroundImage, height } = values;

  const updateImage = (newImage) => {
    if (backgroundImage !== newImage) {
      setValues({
        backgroundColor,
        backgroundImage: newImage,
        height,
      });
    }
  };

  const updateHeight = (newHeight) => {
    if (height !== newHeight) {
      setValues({
        backgroundColor,
        backgroundImage,
        height: newHeight,
      });
    }
  };

  const clear = () => {
    if (backgroundImage || height) {
      setValues({
        backgroundColor: get(uiTheme, 'colors.headerBg'),
        backgroundImage: null,
        height: 0,
      });
    }
  };

  return (
    <HeaderContext.Provider
      value={{
        backgroundColor,
        backgroundImage,
        height,
        clear,
        updateImage,
        updateHeight,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

HeaderProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  uiTheme: PropTypes.shape().isRequired,
};
export default withTheme(HeaderProvider);
